import { ListItem, makeStyles } from '@rneui/themed'
import React, { useCallback, useState } from 'react'
import { Collapsible } from './collapsible'

export interface Props {
  title: string
  value: string | number | undefined
  items: (string | number)[]
  setValue(value: any): void
  required?: boolean
}

export function ValueChooser({
  title,
  value,
  setValue,
  items,
  required,
}: Props) {
  const styles = useStyles()
  const [expanded, setExpanded] = useState(!!required && !value)

  const toggle = useCallback(
    (item: string | number) => {
      if (item === value && !required) {
        setValue(undefined)
      } else {
        setValue(item)
      }

      setExpanded(false)
    },
    [required, setValue, value]
  )

  return (
    <Collapsible
      title={title}
      value={value}
      expanded={expanded}
      onPress={() => setExpanded(!expanded)}
      required={required}
    >
      {items.map((item, index) => (
        <ListItem
          key={index}
          onPress={() => {
            toggle(item)
          }}
          bottomDivider
        >
          <ListItem.Content>
            <ListItem.Title style={styles.option}>{item}</ListItem.Title>
          </ListItem.Content>
          <ListItem.CheckBox
            checked={item === value}
            checkedColor={styles.checkboxChecked.color}
            uncheckedColor={styles.checkboxUnchecked.color}
            checkedIcon="check"
            uncheckedIcon=""
            onPress={() => {
              toggle(item)
            }}
          />
        </ListItem>
      ))}
    </Collapsible>
  )
}
export const useStyles = makeStyles(theme => ({
  option: {
    marginHorizontal: 15,
    color: theme.colors?.grey2,
  },
  checkboxChecked: {
    color: theme.colors?.primary,
  },
  checkboxUnchecked: {
    color: theme.colors?.grey5,
  },
}))
